/**
 * Kleines Registry-Modul, damit der Click-Listener auf die laufende
 * ImpressionHandler-Instanz für Promotions zugreifen kann, ohne einen
 * Zirkel-Import gegen main.js zu erzeugen.
 *
 * Genutzt von:
 * - main.js (registriert den Tracker nach Init)
 * - auto-tracking/listeners/click/index.js (ruft ensurePromotionTracked vor select_promotion auf)
 */

let promotionTracker = null;

export function registerPromotionTracker(handler) {
    promotionTracker = handler;
}

export function getPromotionTracker() {
    return promotionTracker;
}
